'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _optInBanner = require('./components/opt-in-banner');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_optInBanner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/opt-in/lib/index.js
// module id = 1442
// module chunks = 1